module.exports = __webpack_public_path__ + "static/media/img-feature-slider-5.0e1aede8.png";